import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { campwiseattApi } from '../../../utils/AdminDashApi/CampWiseAttApi'
import { BsPlus } from 'react-icons/bs'
import { optionsCampus, optionsShift, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation, optionsexptype, purplebutton200, purplebutton40 } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'

import { approveAttendanceApi } from '../../../utils/AdminDashApi/ApproveAttendanceApi'

const ApproveAttendanceCompmb = () => {

    const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  
  const [activefrommdlnm,setactivefrommdlnm] = useState("")
  const [activetomdl,setactiveTomdl] = useState("")
  const [activetomdlnm,setactiveTomdlnm] = useState("")
 

  const [department,setdepartment] = useState("")
  const [labeldepartment,setlabeldepartment] = useState("")
  const [borderdepartment,setborderdepartment] = useState("")
  const [campus,setcampus]= useState("")
  const [bordercampus,setbordercampus]= useState("")
  const [labelcampus,setlabelcampus]= useState("")
  const [type,settype]= useState("")
  const [bordertype,setbordertype]= useState("")
  const [labeltype,setlabeltype]= useState("")




  const [shifttypemain,setshifttypemain] = useState("")
  const [bordershifttypemain,setbordershifttypemain] = useState("")
  const [labelshifttypemain,setlabelshifttypemain] = useState("")



  const [enddatemain,setenddatemain] = useState("")
  const [borderenddatemain,setborderenddatemain] = useState("")
  const [labelenddatemain,setlabelenddatemain] = useState("")


  const [statustypemain,setstatustypemain] = useState("")
  const [borderstatustypemain,setborderstatustypemain] = useState("")
  const [labelstatustypemain,setlabelstatustypemain] = useState("")

  
  const [employeeID,setemployeeID] = useState("")
  const [borderemployeeID,setborderemployeeID] = useState("")
  const [labelemployeeID,setlabelemployeeID] = useState("")

  const [remarkmain,setremarkmain] = useState("")
  const [borderremarkmain,setborderremarkmain] = useState("")
  const [labelremarkmain,setlabelremarkmain] = useState("")




  const drpfuncstatustypemain=(myval,myid)=>{
    setstatustypemain(myval)
  }
 


const initialState = approveAttendanceApi.data.map(item => ({
  ...item
}));
  const [ischkmodal, setischkmodal] = useState([initialState]);
  const [ischkmodalall, setischkmodalall] = useState([]);






const handleSearch=()=>{
    console.log("searched")
}


  const handleShowEdit=(e,item)=>{
    setShow3(true)

    
  }

  const bottomSave=()=>{
    var finalarr=[]
    approveAttendanceApi.data.map((item,key)=>{
        finalarr.push(item)
    })
    console.log(finalarr)
  }

 
 
  const [roleDrp,setRoledrp] = useState("")
 
 
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")


  
  
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTomdl(dtfinalc)

            
        }
        
        
    }
   
 

    const [show3, setShow3] = useState(false);
    
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(approveAttendanceApi.data)



  const mainfilter=(arr)=>{
      setfilteredArr(arr);    
  }

  const drpfunctiondepartment=(myval,myid)=>{
    setdepartment(myval)
  }
  const drpfunctioncampus=(myval,myid)=>{
    setcampus(myval)
  }
  const drpfunctiontype=(myval,myid)=>{
    settype(myval)
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])

  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % approveAttendanceApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      
    
   
    const [formdata,setfromdata]=useState({
      usersearch:""
    })
    

    // populatedata
    const [name,setname] = useState("")
    const [id,setid] = useState("")

    
   

   
    
    
    const optionsparentmenu = [
      {
        id:1,
        opt:"Home1"
      },
      {
        id:2,
        opt:"Home2"
      },
    ]
    const [parentmenudrp,setparentmenudrp] = useState("")
    const drpfuncparentmenu=(parentmenydrpval,myid)=>{
      setparentmenudrp(parentmenydrpval)
    }
    
  

  
   
  
  const handleInput = (e)=>{
    setfromdata({...formdata,[e.target.name]:e.target.value})
  }


 

  //start
  return (
    <>
          <div className="felxvaluecompmbmain">
              <div className="studentdashboardmobilewrapper">
                  <div className="mobilecontainer">
                      <div className="adminmbheading">
                          <h3>Approve Attendance</h3>
                      </div>
                      <div className="admbwrap ">
                          <Row>
                              <Col xs={12}>
                              <div className="basicinputfield h40p ">

                                <p>Status Type</p>
                                <div className="inputgap h40">
                                    <div className="dropdownwrapper">
                                        <Dropdown2 err={borderstatustypemain} func={drpfuncstatustypemain} myplaceholder={statustypemain}fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsdesignation} />
                                    </div>
                                    <label>{labelstatustypemain}</label>
                                    </div>
                                </div>
                              </Col>
                              <Col xs={12}>
                                <div className="basicinputfield h40p">
                                    <p>Employee ID</p>
                                    <div className="inputgap h35">
                                    <input style={borderemployeeID ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} type="text" value={employeeID} onChange={(e) => setemployeeID(e.target.value)} />
                                    <label>{labelemployeeID}</label>
                                    </div>
                                </div>
                              </Col>
                              <Col xs={12} >

                                <div className="purplebutton" style={{marginTop:"18px"}}>
                                    <button onClick={handleSearch} style={purplebutton200}>Search</button>
                                </div>
                              </Col>
                          </Row>
                      </div>
                      <div className="admbwrap pr0">
                        <div className="tablewrapscroll">
                        <div className="flexvaluetable hrshiftsetuptablediv">
                    <table>
                      <thead>
                        <tr>
                       
                                
                            {
                              approveAttendanceApi.heading.map((item,key)=>{
                                    
                                return(
                                    <>
                                  <th key={key}> <div>{item.head}</div> </th>
                                    
                                    </>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                    
                                  <td>{item.name}</td>
                                  <td>{item.empid}</td>
                                  <td>{item.date}</td>
                                  <td>{item.oripunch}</td>
                                  <td>{item.reqintime}</td>
                                  <td>{item.reqouttime}</td>
                                  <td>{item.status}</td>
                                
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                        </div>
                    <Row>
                    <Col lg={12} className="d-flex justify-content-center">
                      <div className="purplebutton d-inline">

                        <button className='px-4 py-2 my-4' onClick={bottomSave}>
                            Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                      </div>
                      <div className="admbwrap">
                      <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto text-center">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center' >Showing {itemOffset+1} to {itemOffset+10} of {campwiseattApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
                 
               
              </Row>
                      </div>
                  </div>
              </div>
          </div>

    </>
  )
}

export default ApproveAttendanceCompmb